import i18n from '@/plugins/i18n';
import chartTemplate from '../../../utils/templates/cloud.template';

export const MESSAGES = {
  ERROR: {
    SVC_LIST_FAILED: i18n.global.t('unable-to-fetch-services-of-vendor'),
  },
};

export const URL_MAP = {
  GCP: {
    GKE: 'gcp/gke',
  },
  AWS: {
    RDS: 'aws/rds/overview',
    LAMBDA: 'aws/lambda/overview',
    ELASTICACHE: 'aws/elasticache/overview',
    INGRESS: 'aws/ingress/overview',
  },
  AZURE: 'azure',
  DEFAULT: {
    VENDOR: 'gcp',
    SERVICE: 'gke',
    URL: 'gcp/gke',
  },
};

export const GKE_TABS = {
  NODE: 'NODES',
  PODS: 'PODS',
  CONTAINERS: 'CONTAINERS',
};

export const VENDORS = {
  AWS: 'AWS',
  GCP: 'GCP',
  AZURE: 'AZURE',
};

export const SVC = {
  GKE: 'GKE',
  GSQL: 'GSQL',
  RDS: 'RDS',
  LAMBDA: 'LAMBDA',
  ELASTICACHE: 'ELASTICACHE',
  ELB: 'INGRESS',
};

export const FALLBACKS = {
  VENDOR: 'GCP',
  SVC: 'GKE',
};

export const metricList = {
  GKE: {
    NODES: [
      {
        metricName: 'gke_node_memory_total_used_bytes',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('total-memory-used'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: 'GiB',
        },
      },
      {
        metricName: 'gke_node_memory_total_bytes',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.total-memory'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: 'GiB',
        },
      },
      {
        metricName: 'gke_node_cpu_allocatable_utilization',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.total-cpu-allocatable-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent'),
        },
      },
      {
        metricName: 'gke_node_storage_total_bytes',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.storage-total-bytes'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: 'GiB',
        },
      },
      {
        metricName: 'gke_node_storage_total_used_bytes',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.storage-total-used-bytes'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: 'GiB',
        },
      },
    ],
    CONTAINERS: [
      {
        metricName: 'gke_container_cpu_limit_utilization',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.cpu-limit-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent'),
        },
      },
      {
        metricName: 'gke_container_memory_limit_utiization',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.memory-limit-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent'),
        },
      },
      {
        metricName: 'gke_container_ephemeral_storage_used_bytes',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.ephemeral-storage-used'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: 'GiB',
        },
      },
      {
        metricName: 'gke_container_cpu_core_usage_time',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg'),
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max'),
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.container-cpu-usage-time'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.seconds'),
        },
      },
      //Removing it for now as this metric is not clear
      // {
      //   metricName: 'gke_container_restart_count',
      //   valueColumn: 'summation',
      //   headers: [
      //     {
      //       label: 'Tags',
      //       width: '60%',
      //       key: 'label'
      //     },
      //     {
      //       label: 'Avg',
      //       width: '20%',
      //       key: 'avg'
      //     },
      //     {
      //       label: 'Max',
      //       width: '20%',
      //       key: 'max'
      //     }
      //   ],
      //   title: 'Restart count',
      //   graphTitles: {
      //     x: 'Time',
      //     y: 'value'
      //   }
      // }
    ],
    PODS: [
      {
        metricName: 'gke_pod_cpu_limit_utilization',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.cpu-limit-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent') + ' ',
        },
      },
      {
        metricName: 'gke_pod_memory_limit_utiization',
        valueColumn: 'summation',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.memory-limit-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent'),
        },
      },
      {
        metricName: 'gke_pod_volume_utiization',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('aws.rdsFormFields.tags'),
            width: '60%',
            key: 'label',
          },
          {
            label: i18n.global.t('aws.avg') + ' %',
            width: '20%',
            key: 'avg',
          },
          {
            label: i18n.global.t('aws.max') + ' %',
            width: '20%',
            key: 'max',
          },
        ],
        title: i18n.global.t('aws.volume-utilization'),
        graphTitles: {
          x: i18n.global.t('aws.time'),
          y: i18n.global.t('aws.percent'),
        },
      },
    ],
  },
};

export const GKE_TABS_NAVBAR = {
  [GKE_TABS.NODE]: chartTemplate.GKE.navItems[0],
  [GKE_TABS.PODS]: chartTemplate.GKE.navItems[1],
  [GKE_TABS.CONTAINERS]: chartTemplate.GKE.navItems[2],
};

export const GKE_HEADERS_COMMON = [
  {
    label: i18n.global.t('aws.rdsFormFields.tags'),
    width: '100%',
    key: 'label',
  },
  {
    label: i18n.global.t('aws.avg'),
    width: '20%',
    key: 'avg',
  },
  {
    label: i18n.global.t('aws.max'),
    width: '20%',
    key: 'max',
  },
];

export const formulas = {
  NODES: {
    gke_node_memory_total_used_bytes: (value) => {
      return (value / 1073741824).toFixed(3); //bytes to gib
    },
    gke_node_cpu_allocatable_utilization: (value) => {
      return (value / 10).toFixed(3); //Please check gke rules for pod gke-nodes.yml in backend-base
    },
    gke_node_memory_total_bytes: (value) => {
      return (value / 1073741824).toFixed(3); //bytes to gib
    },
    gke_node_storage_total_bytes: (value) => {
      return (value / 1073741824).toFixed(3); //bytes to gib
    },
    gke_node_storage_total_used_bytes: (value) => {
      return (value / 1073741824).toFixed(3); //bytes to gib
    },
  },
  CONTAINERS: {
    gke_container_cpu_limit_utilization: (value) => {
      return (value / 100).toFixed(3); //Please check gke rules for pod gke-container.yml in backend-base
    },
    gke_container_memory_limit_utiization: (value) => {
      return (value / 10000).toFixed(3); //Please check gke rules for pod gke-container.yml in backend-base
    },
    gke_container_ephemeral_storage_used_bytes: (value) => {
      value = Math.floor(value / 10000);
      return (value / 1073741824).toFixed(3); //bytes to gib
    },
    gke_container_cpu_core_usage_time: (value) => {
      return (value / 100000).toFixed(3);
    },
    gke_container_restart_count: (value) => {
      return (value / 100000).toFixed(3);
    },
  },
  PODS: {
    gke_pod_cpu_limit_utilization: (value) => {
      return (value / 100).toFixed(3); //Please check gke rules for pod gke-pods.yml in backend-base
    },
    gke_pod_memory_limit_utiization: (value) => {
      return (value / 100).toFixed(3); //Please check gke rules for pod gke-pods.yml in backend-base
    },
    gke_pod_volume_utiization: (value) => {
      return (value / 1000000).toFixed(8); //Please check gke rules for pod gke-pods.yml in backend-base
    },
  },
};

export const SVC_DISPLAY = {
  GKE: 'GKE',
  GSQL: 'GSQL',
  RDS: 'RDS',
  LAMBDA: 'LAMBDA',
  ELB: 'INGRESS',
  INGRESS: 'INGRESS',
  ELASTICACHE: 'ELASTICACHE',
};

export const SVC_SUBTYPE = {
  GKE: 'GKE',
  GSQL: 'GSQL',
  RDS: 'RDS',
  LAMBDA: 'LAMBDA',
  INGRESS: 'INGRESS',
  ELASTICACHE: 'ELASTICACHE',
};
